import axios from 'lib/apiClient';
import isObject from 'lodash/isObject';
import FileSaver from 'file-saver';
import apiClient from '../lib/apiClient';

export const getConnectCards = (query) => {
  return axios.get('API/1_0/connectCard.php', {
    params: query,
  });
};

export const duplicateConnectCard = (hash) =>
  axios.post('API/1_0/postConnectCardDuplicate.php', { hash });

export const getCardTemplates = () =>
  axios.get('API/1_0/getDefaultConnectCards.php');

export const saveConnectCard = (data) => {
  return axios.post('API/1_0/connectCard.php', data);
};

export const deleteConnectCard = (hash) => {
  return axios.delete(`API/1_0/connectCard.php?hash=${hash}`);
};

export const saveQuestion = async (data) => {
  if (Array.isArray(data.question_possible_answers)) {
    data.question_possible_answers = JSON.stringify(
      data.question_possible_answers,
    );
  }
  if (isObject(data.question_settings)) {
    data.question_settings = JSON.stringify(data.question_settings);
  }
  const result = await axios.post('API/1_0/connectCardQuestion.php', data);
  result.question_settings = JSON.parse(result.question_settings);
  if (typeof result.question_possible_answers === 'string') {
    result.question_possible_answers = JSON.parse(
      result.question_possible_answers,
    );
  }
  return result;
};

export const getQuestions = async (connect_card_hash) => {
  const result = await axios.get('API/1_0/connectCardQuestion.php', {
    params: {
      connect_card_hash,
    },
  });
  return result.map((item) => {
    item.question_possible_answers =
      item.question_possible_answers === '[]'
        ? []
        : item.question_possible_answers;
    if (item.question_settings) {
      try {
        item.question_settings = JSON.parse(item.question_settings);
      } catch (e) {
        item.question_settings = {};
      }
    } else {
      item.question_settings = {};
    }
    return item;
  });
};

export const deleteQuestion = (hash) =>
  axios.delete(`API/1_0/connectCardQuestion.php?hash=${hash}`);

export const getConnectPoints = (query) => {
  return axios.get('API/1_0/connectCardCollection.php', { params: query });
};

export const saveConnectPoint = (data) => {
  return axios.post('API/1_0/connectCardCollection.php', data);
};

export const deleteConnectPoint = (hash) =>
  axios.delete(`API/1_0/connectCardCollection.php?hash=${hash}`);

export const getCardsForConnectPoint = (collection_hash) => {
  return axios.get('API/1_0/connectCardToCollection.php', {
    params: {
      collection_hash,
      load_cards: 1,
      order_by: 'sort_order',
      sort_dir: 'asc',
    },
  });
};

export const getConnectPointCardsCount = async (collection_hash) => {
  const resp = await axios.get('API/1_0/connectCardToCollection.php', {
    params: {
      collection_hash,
    },
  });
  return resp.length;
};

export const saveConnectCardToCollection = (data) => {
  return axios.post('API/1_0/connectCardToCollection.php', data);
};

export const deleteConnectCardFromCollection = (hash) => {
  return axios.delete('API/1_0/connectCardToCollection.php', {
    params: { hash },
  });
};

export const getAnswers = (query) =>
  axios.get('API/1_0/connectCardAnswer.php', { params: query });

export const saveAnswer = (data) =>
  axios.post('API/1_0/connectCardAnswer.php', data);

export const addCount = (hash, type) =>
  client
    .post('API/1_0/connectCard.php', {
      hash,
      counter: type,
      change: '+1',
    })
    .catch((e) => e);

export const getWebsiteLinks = (query) =>
  axios.get('API/1_0/connectCardCollectionLinkedWebsites.php', {
    params: query,
  });

export const saveWebsiteLink = (data) =>
  axios.post('API/1_0/connectCardCollectionLinkedWebsites.php', data);

export const deleteWebsiteLink = (hash) =>
  axios.delete(`API/1_0/connectCardCollectionLinkedWebsites.php?hash=${hash}`);

export const getCollectionWidgetLinkedWebsites = (accountHash) =>
  axios.get('API/1_0/getCollectionWidgetLinkedWebsites.php', {
    params: { account_hash: accountHash },
  });

export const getConnectCardReport = (hash) =>
  axios.get('API/1_0/getConnectCardUsage.php', { params: { hash } });

export const getConnectCardAnswers = (hash) =>
  axios.get('API/1_0/getConnectCardAnswerTable.php', { params: { hash } });

export const exportCsv = (data) => {
  return apiClient
    .post('API/1_0/postCSVfromJSON.php', { rows: data })
    .then((csv) => {
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
      FileSaver.saveAs(blob, 'connect_card_export.csv');
    });
};

export const scanWebsiteUrls = (url) =>
  axios.get('API/1_0/scrapeWebPages.php', { params: { url } });

export const verifyIntegration = (url) =>
  axios
    .get('API/1_0/connectCardVerification.php', { params: { url } })
    .catch((e) => {
      return {
        verified: false,
        message: e.message,
      };
    });

export const getSubmissions = (query) =>
  axios.get('API/1_0/connectCardSubmission.php', { params: query });

export const saveNotificationSettings = (body) =>
  axios.post('API/1_0/notificationTemplate.php', body);

export const deleteNotificationSettings = (hash) =>
  axios.delete(`API/1_0/notificationTemplate.php?hash=${hash}`);

export const getNotificationSettings = (query) =>
  axios.get('API/1_0/notificationTemplate.php', { params: query });

export const duplicateWidget = (hash) =>
  axios.post('API/1_0/postConnectCardWidgetDuplicate.php', { hash });

export const getConnectCardSubmissionReport = (hash, csv) =>
  axios.get('API/1_0/getConnectCardSubmissionReport.php', {
    params: { connect_card_hash: hash, exportCSV: csv ? '1' : '0' },
  });
